import { useEffect } from 'react';
import { Card, Select, Tooltip } from 'antd';
import { useStoreActions, useStoreState } from '../../../store';
import { useSession } from '~/hooks/useSession';
export const ALL_TENANTS = 'All';
export const GLOBAL_TENANT = 'Global';
export const GlobalTenantSelect = () => {
  const fetchTenants = useStoreActions((actions) => actions.tenant.fetchTenants);
  const tenants = useStoreState((state) => state.tenant.tenants);
  const selectedTenant = useStoreState((state) => state.tenant.globallySelectedTenant);
  const setSelectedTenant = useStoreActions((actions) => actions.tenant.setGloballySelectedTenant);
  const sesssionPartnerId = useStoreState((state) => state.session.user?.sessionPartnerId);
  const rerenderWorkflows = useStoreActions((actions) => actions.workflow.rerenderWorkflows);
  const { isShipiumView } = useSession();
  const { Option } = Select;
  useEffect(() => {
    if (sesssionPartnerId) {
      fetchTenants({});
    }
  }, [fetchTenants, sesssionPartnerId]);
  return (
    <>
      {isShipiumView && tenants && !!Object.values(tenants).filter((t) => t.active).length && (
        <Card bodyStyle={{ padding: 10 }}>
          <Tooltip
            placement="right"
            title='Select a tenant if you only want to view, edit and create their configuration. Alternatively set to "All" to view all configuration(regardless of tenant) or "Global" to view only assets with no associated tenants'
          >
            Tenant:{' '}
            <Select
              defaultValue={ALL_TENANTS}
              style={{ minWidth: 150, marginRight: 5 }}
              dropdownMatchSelectWidth={false}
              onChange={(v) => {
                setSelectedTenant(v);
                rerenderWorkflows();
              }}
              value={selectedTenant}
            >
              <Option value={ALL_TENANTS}>All</Option>
              {Object.values(tenants).map((tenant) => {
                return <Option value={tenant.tenantId}>{tenant.name}</Option>;
              })}
            </Select>
          </Tooltip>
        </Card>
      )}
    </>
  );
};
